export default function whatsappLink(facture) {
    const numero = this.formatNumero(facture.numero_acheteur)

    if (!numero) {
        return '#'
    }

    const normalizedDate = String(facture.date_delivery || '').trim()
    const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalizedDate)
    const date = new Date(
        hasTimezone
            ? normalizedDate
            : normalizedDate.replace(' ', 'T') + '+01:00'
    )
    const dateIsValid = !Number.isNaN(date.getTime())

    const dateExpiration = dateIsValid ? `${date.toLocaleDateString(this.langue, {
        timeZone: 'Africa/Douala',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })} à ${date.toLocaleTimeString(this.langue, {
        timeZone: 'Africa/Douala',
        hour: '2-digit',
        minute: '2-digit'
    })}` : 'la date indiquee sur la commande'

    const acheteurName = facture.acheteur?.name || 'cher client'
    const articleName = [facture.article?.marque, facture.article?.nom].filter(Boolean).join(' ') || 'votre article'
    const matricule = facture.matricule || ''

    const message = `Bonjour ${acheteurName},

ALERTE : le délai pour récupérer votre colis expire le ${dateExpiration}.

*Article :* ${articleName}
*Commande :* N°${matricule}

Passé ce délai, les *10 % déposés seront remis au vendeur*.

Merci de récupérer votre colis au point de relais avant cette date et de vous munir d'une *pièce d'identité*.

*En cas d'empêchement*, une autre personne peut récupérer le colis à votre place.

Pour cela :

• Vous devrez nous communiquer son *nom complet* avant l'expiration du délai, par WhatsApp ou par SMS.

• Cette confirmation devra obligatoirement être effectuée à partir du *numéro de téléphone enregistré lors de la commande*.

• La personne mandatée devra se présenter au point de relais avant l'expiration du délai et être munie d'une *pièce d'identité*.

Les numéros pour nous contacter sont disponibles ici :

https://melcameroun.com/contactez-nous`

    return `https://wa.me/${numero}?text=${encodeURIComponent(message)}`
}
